import { useMemo } from 'react';
import { unicodesMap } from './unicodesMap';
import styles from './index.module.scss';
export type SimpleIconName = keyof typeof unicodesMap;

interface IProps {
  name: SimpleIconName;
}

export const resolveGlyph = (iconName: SimpleIconName): string => {
  const glyph = unicodesMap[iconName];
  if (glyph) {
    return String.fromCodePoint(glyph);
  }
  return '';
};

export const iconNames = Object.keys(unicodesMap) as SimpleIconName[];

export const SimpleIcon = ({ name }: IProps): JSX.Element => {
  const icon = useMemo(() => resolveGlyph(name), [name]);
  return <span className={styles.icon}>{icon}</span>;
};
